<template>
  <svg
    id="Ebene_2"
    data-name="Ebene 2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 167.5 38.7"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="-243.12"
        y1="34.42"
        x2="-243.12"
        y2="62.28"
        gradientTransform="translate(-234.98 -38.17) rotate(-180) scale(1.31 -1.31)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="red" />
        <stop offset="1" stop-color="#a00" />
      </linearGradient>
    </defs>
    <g id="MIDGROUND">
      <g id="g91">
        <g id="g66">
          <path
            id="path64"
            class="cls-2"
            d="M163.04,0c4.35,0,4.47,7.44,4.47,11.45h-13.97s.57-11.45,9.5-11.45h0Z"
          />
          <path
            id="path65"
            class="cls-2"
            d="M4.47,0C.11,0,0,7.44,0,11.45h13.97S13.51,0,4.47,0Z"
          />
          <path
            id="path66"
            class="cls-1"
            d="M4.47,0c3.78,0,5.27,6.64,5.5,16.95,0,1.49.23,4.01.34,5.61l1.26,10.08c.46,3.55,3.43,6.07,6.87,6.07h130.52c3.55,0,6.53-2.63,6.87-6.07l1.26-10.08c.23-1.49.46-4.01.69-5.61,1.14-10.19,1.37-16.95,5.15-16.95H4.47Z"
          />
        </g>
      </g>
    </g>
    <text
      x="50%"
      y="50%"
      fill="#ffffff"
      dominant-baseline="middle"
      text-anchor="middle"
      style="font-weight: bold; font-size: 18px"
    >
      {{ label }}
    </text>
  </svg>
</template>
<script>
export default {
  name: "N3BadgeSvg",
  props: {
    label: {
      type: String,
      default: null,
    },
  },
};
</script>
<style lang="scss">
.cls-1 {
  fill: url(#linear-gradient);
}

.cls-1,
.cls-2 {
  stroke-width: 0px;
}

.cls-2 {
  fill: #ac0000;
}
</style>
